// src/constants/universityLogos.js
// Big(ish) list of Maharashtra universities → logo URL (mostly Wikimedia).
// You can swap any URL with your own asset later.


const LOGOS = {
  // ——— State Public Universities ———
  "sant gadge baba amravati university": "https://upload.wikimedia.org/wikipedia/en/4/42/Sant_Gadge_Baba_Amravati_University_logo.png",
  "savitribai phule pune university": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS54TxNc5YgtuRvPoppokAGyNyQCJHx0r1CXA&s",
  "rashtrasant tukadoji maharaj nagpur university": "https://upload.wikimedia.org/wikipedia/en/f/f9/Rashtrasant_Tukadoji_Maharaj_Nagpur_University_logo.jpg",
  "university of mumbai": "https://upload.wikimedia.org/wikipedia/en/7/7a/University_of_Mumbai_coat_of_arms.svg",
  "dr babasaheb ambedkar marathwada university": "https://upload.wikimedia.org/wikipedia/en/2/2a/Dr._Babasaheb_Ambedkar_Marathawada_University_logo.png",
  "shivaji university": "https://upload.wikimedia.org/wikipedia/en/0/07/Shivaji_Univesity_Logo.jpeg",
  "kavayitri bahinabai chaudhari north maharashtra university": "https://upload.wikimedia.org/wikipedia/en/5/53/North_Maharashtra_University_logo.png",
  "gondwana university": "https://upload.wikimedia.org/wikipedia/en/0/0e/Gondwana_University_logo.png",
  "swami ramanand teerth marathwada university": "https://upload.wikimedia.org/wikipedia/en/6/6d/SRTMUN_Logo_Official_Color_-PNG.png",
  "punyashlok ahilyadevi holkar solapur university": "https://upload.wikimedia.org/wikipedia/en/thumb/9/99/Solapur_University_monogram.jpg/250px-Solapur_University_monogram.jpg",
  "sndt women’s university": "https://upload.wikimedia.org/wikipedia/en/4/4a/SNDT_Women%27s_Uni_LOGO.png",
  "yashwantrao chavan maharashtra open university": "https://upload.wikimedia.org/wikipedia/en/5/5b/Yashwantrao_Chavan_Maharashtra_Open_University_logo.png",
  "kavikulaguru kalidas sanskrit university": "https://upload.wikimedia.org/wikipedia/en/8/81/Kavikulaguru_Kalidas_Sanskrit_University_Logo.png",
  "dr homi bhabha state university": "https://upload.wikimedia.org/wikipedia/en/0/0b/Dr._Homi_Bhabha_State_University_logo.png",
  "h snc university": "https://upload.wikimedia.org/wikipedia/commons/5/5a/HSNC_University_Logo.png",

  // ——— Technical / Engineering ———
  "dr babasaheb ambedkar technological university": "https://upload.wikimedia.org/wikipedia/en/6/64/BATU_logo.png",

  // ——— Health / Agriculture / Animal & Fishery ———
  "maharashtra university of health sciences": "https://upload.wikimedia.org/wikipedia/en/7/7a/MUHS_Logo.png",
  "maharashtra animal and fishery sciences university": "https://upload.wikimedia.org/wikipedia/en/8/84/Maharashtra_Animal_and_Fishery_Sciences_University_logo.png",
  "dr balasaheb sawant konkan krishi vidyapeeth": "https://upload.wikimedia.org/wikipedia/en/6/6d/DBSKKV_logo.png",
  "mahatma phule krishi vidyapeeth": "https://upload.wikimedia.org/wikipedia/en/2/23/Mahatma_Phile_Krishi_Vidyapeeth_logo.png",
  "vasantrao naik marathwada krishi vidyapeeth": "https://upload.wikimedia.org/wikipedia/en/0/0b/Vasantrao_Naik_Marathwada_Krishi_Vidyapeeth_logo.png",
  "dr panjabrao deshmukh krishi vidyapeeth": "https://upload.wikimedia.org/wikipedia/en/1/12/Dr._Panjabrao_Deshmukh_Krishi_Vidyapeeth_logo.png",

  // ——— Major Deemed & Private ———
  "bharati vidyapeeth deemed university": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQxzAscM05XIlGK1h4yjAixCLxkpFGkNZExwA&s",
  "symbiosis international university": "https://upload.wikimedia.org/wikipedia/en/0/0a/Symbiosis_International_University_logo.png",
  "mit world peace university": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRB2TTXfHWwjjm_PSGwaXVGO8euCvQWqGqnhg&s",
  "svkm’s nmims": "https://upload.wikimedia.org/wikipedia/en/c/ce/NMIMS_Logo.png",
  "dy patil vidyapeeth pune": "https://upload.wikimedia.org/wikipedia/en/4/4b/DY_Patil_Vidyapeeth%2C_Pune_logo.png",
  "dy patil deemed to be university navi mumbai": "https://upload.wikimedia.org/wikipedia/en/5/5f/DY_Patil_University_Navi_Mumbai_logo.png",
  "vishwakarma university": "https://ik.imagekit.io/syustaging/SYU_PREPROD/Vishwakarma-University-logo_hTpkrrpHF.webp?tr=w-3840",
  "sandip university": "https://upload.wikimedia.org/wikipedia/en/6/6e/Sandip_University_logo.png",
  "amity university mumbai": "https://upload.wikimedia.org/wikipedia/en/0/08/Amity_University_logo.png",
  "mgm institute of health sciences": "https://upload.wikimedia.org/wikipedia/en/1/12/MGM_Institute_of_Health_Sciences_logo.png",
  "tata institute of social sciences": "https://upload.wikimedia.org/wikipedia/en/8/86/Tata_Institute_of_Social_Sciences_Logo.svg",
};

// Common aliases → canonical keys above
const ALIASES = {
  // Short forms / acronyms
  "sgbau": "sant gadge baba amravati university",
  "sppu": "savitribai phule pune university",
  "rtmnu": "rashtrasant tukadoji maharaj nagpur university",
  "mu": "university of mumbai",
  "bamu": "dr babasaheb ambedkar marathwada university",
  "kbc nmu": "kavayitri bahinabai chaudhari north maharashtra university",
  "nmu": "kavayitri bahinabai chaudhari north maharashtra university",
  "pahs us": "punyashlok ahilyadevi holkar solapur university",
  "dbatu": "dr babasaheb ambedkar technological university",
  "mu hs": "maharashtra university of health sciences",
  "ycmou": "yashwantrao chavan maharashtra open university",
  "hsncu": "h snc university",
  "sn dt": "sndt women’s university",
  "mit wpu": "mit world peace university",
  "nmims": "svkm’s nmims",
  "dy patil pune": "dy patil vidyapeeth pune",
  "dy patil navi mumbai": "dy patil deemed to be university navi mumbai",
};

// Fallback (local asset recommended)
const FALLBACK =
  "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg";

// Normalize string for matching
function norm(s = "") {
  return s
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/['’]/g, "")
    .replace(/[,().]/g, " ")
    .replace(/\buniversity\b/g, "university") // keep word boundary
    .replace(/\s+(amravati|nagpur|pune|mumbai|nashik|aurangabad|kolhapur)\b/g, "") // strip city suffix
    .replace(/\s+/g, " ")
    .trim();
}


// Main helper
export function getUniversityLogo(universityName) {
  if (!universityName) return FALLBACK;
  const n = norm(universityName);

  // exact match
  if (LOGOS[n]) return LOGOS[n];

  // try alias
  if (ALIASES[n] && LOGOS[ALIASES[n]]) return LOGOS[ALIASES[n]];

  // heuristic: strip “university” text and try partial contains
  const stripped = n.replace(/\buniversity\b/g, "").trim();
  for (const key of Object.keys(LOGOS)) {
    if (key.includes(stripped) || stripped.includes(key)) {
      return LOGOS[key];
    }
  }

  return FALLBACK;
}

export default getUniversityLogo;
